module.exports = __webpack_public_path__ + "img/x-circle.d9f6fffc.svg";